import { render, staticRenderFns } from "./zy.vue?vue&type=template&id=248f67f2&scoped=true&"
import script from "./zy.vue?vue&type=script&lang=js&"
export * from "./zy.vue?vue&type=script&lang=js&"
import style0 from "./zy.vue?vue&type=style&index=0&id=248f67f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f67f2",
  null
  
)

export default component.exports